<div class="vh-100 d-flex justify-content-center align-items-center">


    <h1 class="text-center">404 Page</h1>
</div>